// React Dependendecies
import React from "react";
import { useState, useEffect } from "react";
import { Link, Routes, Route } from "react-router-dom";

// Components
import useFetch from "../useFetch";
import Calendar from "./Calendar";
const CalendarLogic = () => {

    const { isLoading, error, data } = useFetch(`${process.env.REACT_APP_BACKEND}/api/years`)
    const [year, setYear] = useState(new Date().getFullYear())
    const [selected, setSelectd] = useState('2024')
   
    let years = [];
    let selectedYear = null;
    let yearsDisplay = null;

    function calendarHandle(id) {
        document.getElementsByClassName('underline')[0].classList.remove('underline')
        document.getElementById(`year${id}`).classList.add('underline')
        document.getElementById(id).scrollIntoView({ 
            block: 'start', 
            behavior: 'smooth', 
            inline: 'start'
        })
    }

    if (data) {

        years = data.data;
        
        years.sort(function(a,b){
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            // console.log(a,b)
            return new Date(b.attributes.Year) - new Date(a.attributes.Year);
        }); 
        

        yearsDisplay = years.map((year, index) => {
            if (index === 0) {
                return <h1 className="calendar-logic-year underline" id={ `year${year.attributes.Year}` } onClick={()=> calendarHandle(year.attributes.Year)}>{year.attributes.Year }</h1>
            } else {
                return <h1 className="calendar-logic-year" id={ `year${year.attributes.Year}` }  onClick={()=> calendarHandle(year.attributes.Year)}>{year.attributes.Year }</h1>
            }
        })

        return (
            <div className="calendar-page"> 
                <div className="calendar-line"></div>
                <div id='test' className="calendar-logic-container"> 
                    { yearsDisplay }
                </div>
                <div className="calendar-container"> 
                    <Calendar year={year}/>
                </div>
            </div>
        )
    }
    
}

export default CalendarLogic;